import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiChecklist2ScheduleDescriptionComponent } from './fi-checklist2-schedule-description.component';
import { MatCardModule } from '@angular/material/card';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [CommonModule, MatCardModule, FiAppTextSharedModule, MatExpansionModule, MatIconModule],
    declarations: [FiChecklist2ScheduleDescriptionComponent],
    exports: [FiChecklist2ScheduleDescriptionComponent],
})
export class FiChecklist2ScheduleDescriptionModule {}
